import { Alert, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';

export type OperationError = { message: string; details?: string } | null;

export const OperationErrorAlert = ({ error, title }: { error: OperationError; title: string }) => {
    if (!error) return null;
    return (
        <Alert color="red" title={title} mb="md">
            <Text>{error.message}</Text>
            {error.details && (
                <Text fw={500} mt="xs">
                    {error.details}
                </Text>
            )}
        </Alert>
    );
};
export const confirmAndDeleteTrpc = (config: {
    title: string;
    message: string;
    deleteFn: () => Promise<unknown>;
    successMessage: string;
    onSuccess?: () => void;
}) => {
    modals.openConfirmModal({
        title: config.title,
        children: <Text>{config.message}</Text>,
        labels: { confirm: 'Delete', cancel: 'Cancel' },
        confirmProps: { color: 'red' },
        onConfirm: async () => {
            try {
                await config.deleteFn();
                notifications.show({ title: 'Success', message: config.successMessage, color: 'green' });
                config.onSuccess?.();
            } catch (error) {
                notifications.show({
                    title: 'Delete failed',
                    message: error instanceof Error ? error.message : 'Failed to delete. Please try again.',
                    color: 'red',
                });
            }
        },
    });
};
